import templateOnly, { type TOC } from "@ember/component/template-only";

const MyComponent: TOC<{ Element: HTMLButtonElement }> = templateOnly();
export default MyComponent;
